import { getImageAssetUrl } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/utils'
import { VIEW_MODES } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/constants'

const getShadowFilters = id => `
  <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="shadow-first-layer-filter-${id}">
    <feDropShadow dx="0" dy="0" stdDeviation="5" flood-color="#000000" flood-opacity="0.85" />
  </filter>
  <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="shadow-layers-filter-${id}">
    <feDropShadow dx="0" dy="0" stdDeviation="4" flood-color="#000000" flood-opacity="0.45" />
  </filter>
`

const getOverlayFilter = (id, filterType, imagePath, imageWidth, imageHeight) => {
  const imageUrl = getImageAssetUrl(imagePath)

  return `
    ${getShadowFilters(id)}
    <filter id="filter-${filterType}-${id}" x="0" y="0" height="100%" width="100%">
      <feImage id="filter-${filterType}-image-${id}" xlink:href="${imageUrl}"
              result="img" x="0" y="0" height="${imageHeight}" width="${imageWidth}"></feImage>
      <feColorMatrix result="grayscale" in="img" type="saturate" values="0"></feColorMatrix>
      <feBlend in="SourceGraphic" in2="grayscale" mode="multiply"></feBlend>
    </filter>
  `
}

const getSpotlightFilters = (id, imagePath, imageWidth, imageHeight) => {
  // TODO
  const imageUrl = getImageAssetUrl(imagePath)
  // const imageUrl =
  //   'https://assets-master.review.vpn.aytm.com/media/cache/resolve/resizelm_2000x2000_white/images.aytm.com/2QlqrwIFgjw1TOHOXqsMVjhv.jpeg'

  return `
    <image id="image-source-${id}"
          href="${imageUrl}"
          height="${imageHeight}"
          width="${imageWidth}" />

    <filter id="orange-color-filter-${id}" x="-10%" y="-10%" width="120%" height="120%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse" color-interpolation-filters="linearRGB">
      <feColorMatrix type="matrix" values=".33 .33 .33 0 0
      .33 .33 .33 0 0
      .33 .33 .33 0 0
      0 0 0 1 0" in="SourceGraphic" result="colormatrix"/>
      <feComponentTransfer in="colormatrix" result="componentTransfer">
        <feFuncR type="table" tableValues="0 0.76 1"/>
        <feFuncG type="table" tableValues="0 0.37 1"/>
        <feFuncB type="table" tableValues="0 0.01 1"/>
        <feFuncA type="table" tableValues="0 1"/>
      </feComponentTransfer>
    </filter>

    <filter id="spotlight-duotone-blue-${id}" x="-10%" y="-10%" width="120%" height="120%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse" color-interpolation-filters="linearRGB">
      <feColorMatrix type="matrix" values=".33 .33 .33 0 0
        .33 .33 .33 0 0
        .33 .33 .33 0 0
        0 0 0 1 0" in="SourceGraphic" result="colormatrix"/>
      <feComponentTransfer in="colormatrix" result="componentTransfer">
        <feFuncR type="table" tableValues="0 0 0.11 0.52"/>
        <feFuncG type="table" tableValues="0 0.08 0.29 0.7"/>
        <feFuncB type="table" tableValues="0 0.09 0.3 0.75"/>
        <feFuncA type="table" tableValues="0 1"/>
      </feComponentTransfer>
    </filter>
  `
}

const getClusterFilters = id => `
  <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="cluster-shadow-filter-${id}">
    <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"/>
    <feGaussianBlur stdDeviation="4" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
    <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.35 0" in="shadowBlurOuter1" type="matrix" result="shadowMatrixOuter1"/>
    <feMerge>
      <feMergeNode in="shadowMatrixOuter1"/>
      <feMergeNode in="SourceGraphic"/>
    </feMerge>
  </filter>
`

const getDotsGradient = () => `
  <radialGradient id="dots-gradient-linear">
    <stop id="a" offset="6" stop-color="#ffffff"/>
    <stop id="b" offset="7" stop-color="#DCDCDC"/>
  </radialGradient>
`

export const getSvgDefs = (id, viewType, options = {}) => {
  const { imagePath, imageWidth, imageHeight } = options

  switch (viewType) {
    case VIEW_MODES.HEATMAP:
    case VIEW_MODES.HEATMAPCLUSTERS:
    case VIEW_MODES.COLDMAP:
      return getShadowFilters(id)

    case VIEW_MODES.OVERLAY:
      return getOverlayFilter(id, VIEW_MODES.OVERLAY, imagePath, imageWidth, imageHeight)

    case VIEW_MODES.OVERLAYCLUSTERS:
      return getOverlayFilter(id, VIEW_MODES.OVERLAYCLUSTERS, imagePath, imageWidth, imageHeight)

    case VIEW_MODES.SPOTLIGHT:
      return getSpotlightFilters(id, imagePath, imageWidth, imageHeight)

    case VIEW_MODES.DOTS:
      return getDotsGradient()

    case VIEW_MODES.CLUSTERS:
      return getClusterFilters(id)

    default:
      return ''
  }
}

export const createBlurFilter = (defs, id, index, stdDeviation) => {
  const filter = defs.append('filter').attr('id', `blur-spotlight-${id}-${index}`).attr('class', 'blur-filter')

  return filter.append('feGaussianBlur').attr('in', 'SourceGraphic').attr('stdDeviation', stdDeviation)
}

export const createSpotlightMask = (defs, id, index, width, height) => {
  const mask = defs
    .append('mask')
    .attr('id', `svg-spotlight-${id}-mask-${index}`)
    .attr('x', 0)
    .attr('y', 0)
    .attr('height', height)
    .attr('width', width)

  mask.append('rect').attr('x', 0).attr('y', 0).attr('height', height).attr('width', width).style('fill', 'white')

  return mask
    .append('g')
    .attr('id', `svg-spotlight-${id}-mask-group-${index}`)
    .attr('filter', `url(#blur-spotlight-${id}-${index})`)
}
